import React from "react";
import Button from "components/CustomButton";
import post_img from "assets/img/post_img.svg";
import { useHistory } from "react-router-dom";
import LazyLoadImage from "components/LazyLoadImage";

export default ({ post }) => {
  const history = useHistory();

  const goToWaterCooler = () => {
    if (post?.is_private) {
      history.push(
        `/teams/${post?.team_id}/watercooler?waterCoolerStatus=true&post_id=${post?.id}&private=true`
      );
      return;
    }
    history.push(
      `/teams/${post?.team_id}/watercooler?waterCoolerStatus=true&post_id=${post?.id}&private=false`
    );
  };

  return (
    <>
      <div className="row va-center">
        <div className="col-lg-6 pl-0">
          <Button
            buttonClass="grad_btn join-btn"
            buttonStyle={{ width: "100%" }}
            onClick={goToWaterCooler}
          >
            Join
          </Button>
        </div>
        <div className="col-lg-6 pr-0">
          <LazyLoadImage
            image={post_img}
            key="waterCoolerPost"
            alt="waterCoolerPost"
            imageClassName={"full_w waterCoolerPostImage"}
          />
        </div>
      </div>
    </>
  );
};
